// Lựa chọn dùng chung cho các form cấu hình giao diện app (nút giữa thanh tab,
// nút hướng dẫn trang chủ) — đều ghi vào /img/app-tab-config.json.
//
// Màn hình app cho phép mở — PHẢI khớp SCREEN_WHITELIST ở mobile
// (open-utility-block.ts) và whitelist backend (app-tab-config-json-writer.js).
export const SCREEN_OPTIONS = [
    { value: "CommunityFeed", label: "Kênh Cộng Đồng (mặc định)" },
    { value: "Vouchers", label: "Đổi Voucher" },
    { value: "Referral", label: "Giới thiệu bạn" },
    { value: "Cashback", label: "Hoàn tiền" },
    { value: "MyOrders", label: "Đơn của tôi" },
    { value: "PriceWatch", label: "Theo dõi giá" },
    { value: "LinkConverter", label: "Rải link" },
    { value: "ShopeeVideo", label: "Video độc quyền" },
    { value: "Withdraw", label: "Rút tiền" },
    { value: "Leaderboard", label: "Bảng xếp hạng" },
    { value: "SavedProducts", label: "Sản phẩm đã lưu" },
    { value: "Notifications", label: "Thông báo" },
    { value: "Settings", label: "Cài đặt" },
    { value: "Help", label: "Trợ giúp" },
];

// Riêng nút hướng dẫn được mở thêm màn Bài viết (cần nhập ID bài).
// Nút giữa KHÔNG có ô nhập ID nên không dùng lựa chọn này.
export const GUIDE_SCREEN_OPTIONS = [
    { value: "PostDetail", label: "Bài viết (nhập ID bài)" },
    ...SCREEN_OPTIONS,
];

export const OPEN_MODE_OPTIONS = [
    { value: "screen", label: "Mở màn hình app" },
    { value: "appview", label: "App view (WebView nhúng)" },
    { value: "webview", label: "Web view (trong app)" },
    { value: "external", label: "Trình duyệt ngoài" },
];
